export interface ITrafficAndEngagementBaseWidgetProps {
    isLoading: boolean;
    isError?: boolean;
    data: any;
    params?: any;
}

export interface ITrafficAndEngagementWidgetProps extends ITrafficAndEngagementBaseWidgetProps {
    subtitleFilters?: any;
    hasGA?: boolean;
    hasA2d?: boolean;
    isGAPrivate?: boolean;
    showBetaBranchData?: boolean;
    showA2d?: boolean;
}

export interface IBaseSingleRequestParams {
    country: string;
    from: string;
    includeSubDomains: boolean;
    isWindow: boolean;
    timeGranularity: string;
    to: string;
    webSource: string;
    keys: string;
    compareFrom?: string;
    compareTo?: string;
}

type IWebsiteAnalysisTrafficApiParams = {
    country: string;
    from: string;
    to: string;
    includeSubDomains: boolean;
    isWindow: boolean;
    timeGranularity: string;
    webSource: string;
    category: string;
    key: string;
    isWWW: string;
};

export type IWebsiteAnalysisTrafficRequestParams = {
    country: string;
    from: string;
    to: string;
    includeSubDomains: boolean;
    isWindow: boolean;
    timeGranularity: string;
    webSource: string;
    keys: string;
    ShouldGetVerifiedData?: boolean;
    beta?: boolean;
    compareFrom?: string;
    compareTo?: string;
    latest?: string;
};

type IWebRanksRecord = {
    Domain: string;
    Favicon: string;
    Rank: number;
};

type IDeviceDistributionRecord = {
    Domain: string;
    Favicon: string;
    DesktopMobileShareVisits: [number, number];
};

type ITotalVisitsRecord = {
    Domain: string;
    Favicon: string;
    TotalVisits: number;
    Change: number;
    ShareOfVisits: number;
};

type IWebRanksResponseHeader = "country" | "category";

export type IWebRanksResponseData = {
    Data: IWebRanksRecord[];
    TotalCount: number;
    Header: { IWebRanksResponseHeader: string };
};

export type IEngagementVisitsTable = {
    Data: IWebRanksRecord[];
    TotalCount: number;
};

export type IDeviceDistributionResponseData = {
    Data: IDeviceDistributionRecord[];
    TotalCount: number;
    KeysDataVerification?: { string: boolean };
};

export type IDeviceTotalVisitsResponseData = {
    Data: ITotalVisitsRecord[];
    TotalCount: number;
    KeysDataVerification?: { string: boolean };
};

export const RankByMode = {
    Country: "WebRanksCountry",
    Global: "WebRanksGlobal",
    Industry: "WebRanksCategory",
} as const;

export type RankByMode = (typeof RankByMode)[keyof typeof RankByMode];

interface ITrafficModeContainer {
    subtitleFilters: any;
    params: any;
    showGAApprovedData: boolean;
    apiParams: IWebsiteAnalysisTrafficApiParams;
    isGAPrivate: boolean;
    websiteAnalysisApiService: any;
}

interface ITrafficSingleModeContainer extends ITrafficModeContainer {
    props: any;
}

export interface ITrafficSingleBetaModeContainer extends ITrafficSingleModeContainer {
    showBetaBranchData: boolean;
}

export interface ITrafficCompareModeProps extends ITrafficModeContainer {
    showBetaBranchData?: boolean;
}

export interface ITrafficCompareBetaModeProps extends ITrafficModeContainer {
    showBetaBranchData: boolean;
}

export interface IDeviceDistributionCompareWidget extends ITrafficAndEngagementWidgetProps {
    onRankModeChange: (rankByMode: { id: RankByMode; text: string }) => void;
    selectedRankMode: RankByMode;
}

export interface ITrafficWidgetsContainerProps {
    props: any;
    subtitleFilters?: any;
    params: any;
    showGAApprovedData: boolean;
    showBetaBranchData: boolean;
    apiParams: any;
    isGAPrivate: boolean;
    websiteAnalysisApiService: any;
}

// Shared types for widget params
export interface IWidgetBaseParams {
    country: number;
    from: string;
    to: string;
    key: string;
    webSource: string;
    isWindow: boolean;
    isWWW: boolean;
}

export interface IWidgetPOPParams extends IWidgetBaseParams {
    duration: string;
    comparedDuration: string;
    compareFrom: string;
    compareTo: string;
}

export interface ICommonWidgetProps {
    dateRangeText: string;
    countryText: string;
    countryCode: number;
    showGAApprovedData: boolean;
    isGAPrivate: boolean;
}
